import {CUSTOMER_SUCCESS, OLD_ORDERS_SUCCESS, ORDER_SUCCESS, SEND_ORDER_SUCCESS} from 'new-constants/api.constants';
import {getCacheWithMergedUpdatedOrdersByRestaurants, getOrderWithVatTotalByPercent} from 'helpers/order.helper';
import groupBy from 'lodash/groupBy';
import {PRIVATE_ORDER_UPDATE} from 'new-constants/pusher.constants';
import {OrderStatuses} from 'new-constants/common.constants';
import {DONE_LOGOUT_CONFIRMATION} from 'new-constants/popup.constants';
import {OrderState} from './order.reducer.types';
import {GET_HISTORY_ORDERS_SUCCESS} from '../constants/api.constants';

const initialState: OrderState = {
	cache: [],
};

export const orderReducer = (previousState = initialState, action): OrderState => {
	switch (action && action.type) {
		case SEND_ORDER_SUCCESS:
			if (!action.payload.data.order) {
				return previousState;
			}

			const restaurantId = !!action.payload.data.order.pickupPlaceId
				? action.payload.data.order.pickupPlaceId
				: action.payload.data.order.restaurantId;

			return {
				...previousState,
				cache: getCacheWithMergedUpdatedOrdersByRestaurants(
					[
						{
							restaurantId: restaurantId,
							orders: [getOrderWithVatTotalByPercent(action.payload.data.order)],
						},
					],
					previousState.cache
				),
			};
			break;
		case OLD_ORDERS_SUCCESS:
			return {
				...previousState,
				cache: getCacheWithMergedUpdatedOrdersByRestaurants(
					[
						{
							restaurantId: action.payload.data.restaurantId,
							orders: action.payload.data.orders.map(order => getOrderWithVatTotalByPercent(order)),
						},
					],
					previousState.cache
				),
			};
			break;
		case CUSTOMER_SUCCESS:
			if (action.payload.data.purchases) {
				const purchasesByRestaurants = groupBy(action.payload.data.purchases, purchase =>
					purchase.pickupPlaceId ? purchase.pickupPlaceId : purchase.restaurantId
				);

				const mappedOrdersByRestaurants = Object.entries(purchasesByRestaurants).map(entry => {
					return {
						restaurantId: Number.parseInt(entry[0]),
						orders: entry[1].map(purchase => getOrderWithVatTotalByPercent(purchase)),
					};
				});

				return {
					...previousState,
					cache: getCacheWithMergedUpdatedOrdersByRestaurants(mappedOrdersByRestaurants, previousState.cache),
				};
			}

			return previousState;
			break;
		case ORDER_SUCCESS: {
			const restaurantId = action.payload.data.order.pickupPlaceId || action.payload.data.order.restaurantId;

			let orderRestaurant = previousState.cache.find(restaurant => restaurant.restaurantId === restaurantId);

			if (!orderRestaurant) {
				orderRestaurant = {
					restaurantId,
					orders: [],
				};
			}

			return {
				...previousState,
				cache: [
					...previousState.cache.filter(restaurant => restaurant.restaurantId !== restaurantId),
					{
						restaurantId,
						orders: [
							...orderRestaurant.orders.filter(order => order.orderId !== action.payload.data.order.orderId),
							getOrderWithVatTotalByPercent(action.payload.data.order),
						],
					},
				],
			};
		}
			break;
		case PRIVATE_ORDER_UPDATE:
			return {
				...previousState,
				cache: [
					...previousState.cache.map(restaurant => {
						if (restaurant.restaurantId === action.data.restaurantId) {
							return {
								...restaurant,
								orders: restaurant.orders.map(order => {
									if (order.orderId === action.data.orderId) {
										return {
											...order,
											isConfirmed: action.data.status === OrderStatuses.confirmed,
											isDelivered: action.data.status === OrderStatuses.delivered,
											isCanceled: action.data.status === OrderStatuses.canceled,
											pickupRef: action.data.orderRef,
											paidByOtherCustomer: action.data.paidByOtherCustomer,
											stamp: action.data.status === OrderStatuses.canceled ? '' : order.stamp,
											statusString: action.data.statusString,
											statusTime: action.data.statusTime,
											pickupTime: action.data.status === OrderStatuses.confirmed ? action.data.pickupTime : order.pickupTime,
											deliveryTime:
												action.data.status === OrderStatuses.delivered ? action.pickupTime : order.deliveryTime,
										};
									} else {
										return order;
									}
								}),
							};
						} else {
							return restaurant;
						}
					}),
				],
			};

			break;

		case DONE_LOGOUT_CONFIRMATION:
			return {
				...previousState,
				cache: [],
			};
			break;

		case GET_HISTORY_ORDERS_SUCCESS:
			if (!action.payload?.data) {
				return previousState;
			}

			return {
				...previousState,
				cache: getCacheWithMergedUpdatedOrdersByRestaurants([
					...action.payload.data.map(restaurantOrders => ({
						restaurantId: restaurantOrders.restaurantId,
						orders: restaurantOrders.orders
					}))
				], previousState.cache)
			};
			return previousState;
			break;
		default:
			return previousState;
	}
};
